import { createFeature, createReducer } from '@ngrx/store';

import { jobTagsReducers } from './job-tags.reducer';
import { jobTagsInitialState } from './job-tags.state';

export const jobTagsFeature = createFeature({
  name: 'jobV3Tags',
  reducer: createReducer(jobTagsInitialState, ...jobTagsReducers),
});
